var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',{},[_c('span',{class:_vm.getRequestColour(_vm.request)},[_vm._v(" "+_vm._s(_vm.request)+" ")]),_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('h4',{},[_vm._v(" "+_vm._s(_vm.endPoint ? '/' : '')+_vm._s(_vm.endPoint)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }